import React from 'react';
import { PageHeader } from '../components/PageHeader';
import { Experience } from '../components/Experience';
import { SectionNav } from '../components/SectionNav';
export function TrackRecord() {
  return <>
      <PageHeader index="07" title="Executive Career Track Record" intro="The detailed mandate held in each senior role — the accountability owned, the programs led, and the outcomes delivered." data-id="element-435" data-mp="bgdm3znrlr84" />
      <Experience data-id="element-436" data-mp="1kjz1mcf6fc3" />
      <SectionNav currentIndex="07" data-id="element-437" data-mp="1l3k3bxd9juc" />
    </>;
}